import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { selectIsAuthenticated } from 'store/selectors';

const GuestGuard = ({ children, path }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={path} />;
  }

  return children;
};

export default GuestGuard;
